import {getMethod} from '@/api'

async function get(request) {
    return await getMethod('/proxy/inboundEmails', request)
}

export {get}
